/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Row,
  Spin,
  Tabs,
  message,
} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, RedoOutlined } from '@ant-design/icons';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  deletePercepcionIMSS,
  getPercepcionesIMSS,
  patchPercepcionIMSS,
  postPercepcionIMSS,
} from 'api/catalogos/PercepcionesImss';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { NOMBRES_PATTERN } from 'utils/patterns';
// import { getTiposDeSeguridadSocial } from 'api/catalogos/tipoDeSeguridadSocial';
import { getDiasDePagoCalculo } from 'api/catalogos/DiasDePagoParaCalculo';
import { getTiposDeSueldos } from 'api/catalogos/tiposDeSueldos';
import { getValoresParaFactor } from 'api/catalogos/ValorParaFactor';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { set } from 'lodash';
import { getValoresDeCalculo } from 'api/catalogos/ValorCalculo';
import moment from 'moment';
import TabPane from 'antd/lib/tabs/TabPane';

export const PercepcionIMSSPermission = {
  permissionModel: 'percepcionimss',
};

const baseURI = 'nominas/percepciones-imss/';

const PercepcionIMSS = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [disableFields, setDisableFields] = useState(false);
  const [tiposPercepcion, setTiposPercepciones] = useState([]);
  const [tiposSueldo, setTiposSueldos] = useState([]);
  const [valorFactor, setValorFactor] = useState([]);
  const [diasPago, setDiasPago] = useState([]);
  const [valoresCalculo, setValoresCalculo] = useState([]);
  const [currentTab, setCurrentTab] = useState('percepciones');

  const fetchData = async () => {
    setLoading(true);
    const _data = await getPercepcionesIMSS();
    setData(Array.isArray(_data) ? _data : (_data.results || []));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
        _tiposPercepcion,
        _tiposSueldo,
        _valorFactor,
        _diasPago,
        _valoresCalculo,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPercepcionesIMSS(),
        getPercepciones(),
        getTiposDeSueldos(),
        getValoresParaFactor(),
        getDiasDePagoCalculo(),
        getValoresDeCalculo(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTiposPercepciones(_tiposPercepcion);
        setTiposSueldos(_tiposSueldo);
        setData(Array.isArray(_data) ? _data : (_data.results || []));
        setValorFactor(_valorFactor);
        setDiasPago(_diasPago);
        setValoresCalculo(_valoresCalculo);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    fetchData([]);
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const saved = await patchPercepcionIMSS(key, { estados_globales: ESTATUS_AUTORIZADO });
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const saved = await patchPercepcionIMSS(key, { estados_globales: ESTATUS_CANCELADO });
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const saved = await patchPercepcionIMSS(key, { estados_globales: ESTATUS_ACTIVO });
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickEdit = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;

    const match = data?.find((item) => item.id === key);
    setTimeout(() => {
      if (match) {
        setTimeout(() => {
          form.setFieldsValue(formatReceived(match));
          setDisableFields(match?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      if (values.vigencia_final) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      const [key] = selectedRowKeys;
      const saved = await (key ? patchPercepcionIMSS(key, values) : postPercepcionIMSS(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePercepcionIMSS(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const parsedRecord = {
      ...record,
      vigencia_final: record.vigencia_final ? moment(record.vigencia_final) : null,
    };

    form.setFieldsValue(parsedRecord);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Percepción',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 300,
      render: (val, record) => {
        // El backend ya resuelve "Clave - Descripción" directo del FK
        // (percepcion_clave_y_descripcion), incluso si la Percepción
        // referenciada ya fue dada de baja y no aparece en el catálogo
        // de activas (tiposPercepcion) usado para el Select de Agregar.
        if (record?.percepcion_clave_y_descripcion) {
          return record.percepcion_clave_y_descripcion;
        }
        const resultado = tiposPercepcion.find((e) => e.id === val);
        return resultado ? `${resultado.clave} - ${resultado.descripcion || resultado.concepto || ''}` : 'No encontrada';
      },
    },
    {
      titleText: 'Tipo para IMSS',
      dataIndex: 'tipo_de_sueldo',
      key: 'tipo_de_sueldo',
      width: 200,
      render: (val) => tiposSueldo.find((e) => e.id === val)?.descripcion || 'No encontrada',
    },
    {
      titleText: 'Aplica para Factor SBC',
      dataIndex: 'aplica_para_factor_sbc',
      key: 'aplica_para_factor_sbc',
      width: 200,
      render: (val) => (val ? 'SI' : 'NO'),
    },
    {
      titleText: 'Aplica Importe que No Integra',
      dataIndex: 'aplica_importe_no_integra',
      key: 'aplica_importe_no_integra',
      width: 250,
      render: (val) => (val ? 'SI' : 'NO'),
    },
    {
      titleText: 'Valor de Cálculo',
      dataIndex: 'valor_de_calculo',
      key: 'valor_de_calculo',
      width: 150,
      render: (val) => (val ? `${val}%` : ''),
    },
    {
      titleText: 'Valor Base para Cálculo',
      dataIndex: 'valor_base_para_calculo',
      key: 'valor_base_para_calculo',
      width: 200,
      render: (val) => valoresCalculo.find((e) => e.id === val)?.descripcion || '',
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Tabs activeKey={currentTab} onChange={setCurrentTab}>
          {/* PESTAÑA 1: PERCEPCIONES */}
          <TabPane tab="Percepciones" key="percepciones">
            <Table
              cols={columns}
              data={data}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit: () => onClickEdit(),
                onClickDelete,
              }}
              baseURI={baseURI}
              allowImport
              disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
              permission={permission}
              allowExportPDF={false}
              customActions={[
                {
                  onClick: () => setVisibleAutorizar(true),
                  permission: { model: 'percepcionimss', action: 'autorizar' },
                  icon: <CheckCircleOutlined />,
                  text: 'Autorizar',
                  disabledBySelection: true,
                  disabled: !selectedRowKeys?.length
                    || selectedData?.estados_globales === ESTATUS_AUTORIZADO
                    || selectedData?.estados_globales === ESTATUS_CANCELADO,
                  className: 'success',
                },
                {
                  onClick: () => setVisibleCancelar(true),
                  permission: { model: 'percepcionimss', action: 'cancelar' },
                  icon: <CloseCircleOutlined />,
                  text: 'Cancelar',
                  disabledBySelection: true,
                  disabled: !selectedRowKeys?.length
                    || selectedData?.estados_globales === ESTATUS_CANCELADO,
                  className: 'cancel',
                },
                {
                  onClick: () => setVisibleReactivar(true),
                  permission: { model: 'percepcionimss', action: 'reactivar' },
                  icon: <RedoOutlined />,
                  text: 'Reactivar',
                  disabledBySelection: true,
                  disabled: !selectedRowKeys?.length
                    || selectedData?.estados_globales === ESTATUS_ACTIVO,
                  className: 'success',
                },
              ]}
            />
            <Modal
              open={open}
              closable={false}
              maskClosable={!loading}
              keyboard={!loading}
              footer={null}
              title={(
                <FormSubmitControls
                  label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Percepciones IMSS`}
                  onFinish={onFinish}
                  onCancel={onCancel}
                  loading={loading}
                  allowSave={!disableFields}
                />
            )}
              onCancel={onCancel}
              forceRender
            >
              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                scrollToFirstError
                name="general"
                initialValues={{
                  estados_globales: ESTATUS_ACTIVO,
                }}
              >
                <Col xs={24} sm={24} md={24}>
                  <Form.Item name="percepcion" label="Percepción" rules={rules.required} hasFeedback>
                    <Select
                      keyProp="id"
                      dataSource={tiposPercepcion}
                      render={(value) => `${value?.clave} - ${value?.descripcion || ''}`}
                      allowClear
                      placeholder="Seleccione una percepción"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="tipo_de_sueldo" label="Tipos Para IMSS" rules={rules.required} hasFeedback>
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={tiposSueldo}
                      allowClear
                      placeholder="Seleccione un Tipo"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>

                  <Form.Item
                    name="aplica_para_factor_sbc"
                    label="Aplica Para Factor SBC"
                    rules={rules.required}
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                {/* 1. Campo principal que detona la condición */}
                <Col span={24}>
                  <Form.Item
                    name="aplica_importe_no_integra"
                    label="Aplica Importe que No Integra"
                    rules={rules.required}
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                {/* 2. Envoltorio de Ant Design que "escucha" los cambios sin hooks */}
                <Form.Item
                  noStyle
              // eslint-disable-next-line max-len
                  shouldUpdate={(prevValues, currentValues) => prevValues.aplica_importe_no_integra !== currentValues.aplica_importe_no_integra}
                >
                  {({ getFieldValue }) => {
                    // Evaluamos el valor actual del campo
                    const aplicaImporte = getFieldValue('aplica_importe_no_integra');

                    // Aplicamos tu estructura ternaria
                    return aplicaImporte ? (
                      <>
                        <Col span={24}>
                          <Form.Item
                            name="valor_para_factor"
                            label="Unidad de Cálculo"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              labelProp="nombre"
                              keyProp="id"
                              dataSource={valorFactor}
                              allowClear
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Form.Item
                            name="valor_de_calculo"
                            label="Valor de Cálculo"
                            rules={rules.required}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              min={0}
                              max={100}
                              formatter={(value) => `${value}%`}
                              parser={(value) => value.replace('%', '')}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Form.Item
                            name="valor_base_para_calculo"
                            label="Valor Base para Cálculo"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              labelProp="descripcion"
                              keyProp="id"
                              dataSource={valoresCalculo}
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : null;
                  }}
                </Form.Item>
                <Col span={24}>
                  <Form.Item name="dias_para_calculo" label="Días Para Cálculo" rules={rules.required} hasFeedback>
                    <Select
                      labelProp="dias"
                      keyProp="id"
                      dataSource={diasPago}
                      allowClear
                      placeholder="Seleccione un Tipo"
                    />
                  </Form.Item>
                </Col>

                {/* 3. Vigencia Final queda fuera del condicional */}
                <Col span={24}>
                  <Form.Item
                    name="vigencia_final"
                    label="Vigencia Final"
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estados}
                      disabled={selectedRowKeys.length <= 0 || disableFields}
                    />
                  </Form.Item>
                </Col>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Form>
            </Modal>
          </TabPane>

          {/* PESTAÑA 2: REGISTRO (Vacía por el momento) */}
          <TabPane tab="Registro" key="registro">
            <div style={{ padding: '3rem', textAlign: 'center', color: '#999' }} />
          </TabPane>

        </Tabs>

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="El Registro Seleccionado"
          loading={loading}
        />

        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle="autorizar la Percepción IMSS seleccionada"
          open={visibleAutorizar}
          loading={loading}
        />

        <ModalConfirmation
          onFinish={onConfirmCancelar}
          ConfirmCancel
          onCancel={() => setVisibleCancelar(false)}
          contentTitle="cancelar la Percepción IMSS seleccionada"
          open={visibleCancelar}
          loading={loading}
        />

        <ModalConfirmation
          onFinish={onConfirmReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          contentTitle="reactivar la Percepción IMSS seleccionada"
          open={visibleReactivar}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default PercepcionIMSS;
